import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoginOverlay } from '@bibliocommons/login';
import AuthActions from '../actions/AuthActions';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

const LoginOverlayContainer = ({
  authActions,
  loginOverlayOpen,
  loginErrorMessage,
  loading,
  numericPasswordRequired,
  getCardLink,
  localBranch,
  allowUserPinChange
}) => (
  <LoginOverlay
    loginOverlayOpen={loginOverlayOpen}
    login={authActions.login}
    loginErrorMessage={loginErrorMessage}
    handleClose={authActions.closeLoginDialog}
    loading={loading}
    numericPasswordRequired={numericPasswordRequired}
    getCardLink={getCardLink}
    localBranch={localBranch}
    allowUserPinChange={allowUserPinChange}
  />
);

LoginOverlayContainer.propTypes = {
  authActions: PropTypes.shape({
    login: PropTypes.func,
    logout: PropTypes.func,
    loadUser: PropTypes.func,
    closeLoginDialog: PropTypes.func
  }),
  loginErrorMessage: PropTypes.string,
  loginOverlayOpen: PropTypes.bool,
  loading: PropTypes.bool,
  numericPasswordRequired: PropTypes.bool,
  getCardLink: PropTypes.string,
  localBranch: PropTypes.string,
  allowUserPinChange: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators(AuthActions, dispatch)
});

const mapStateToProps = state => {
  const currentLibrary = currentLibrarySelector(state);
  const errorClassification = state.getIn(['auth', 'loginError', 'classification']);
  const loginErrorMessage = errorClassification
    ? `errors.${errorClassification}`
    : state.getIn(['auth', 'loginError', 'message']);

  return {
    loginErrorMessage,
    loginOverlayOpen: state.getIn(['auth', 'loginDialogOpen']),
    loading: state.getIn(['auth', 'loading']),
    localBranch: state.getIn(['app', 'localBranch']),
    getCardLink: currentLibrary.get('getCardLink') || '',
    numericPasswordRequired: currentLibrary.get('numericPasswordRequired', false),
    allowUserPinChange: currentLibrary.get('allowUserPinChange', false)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginOverlayContainer);
